import { render, staticRenderFns } from "./download-work-permit-dialog.component.vue?vue&type=template&id=5e92d0dc"
import script from "./download-work-permit-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./download-work-permit-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e92d0dc')) {
      api.createRecord('5e92d0dc', component.options)
    } else {
      api.reload('5e92d0dc', component.options)
    }
    module.hot.accept("./download-work-permit-dialog.component.vue?vue&type=template&id=5e92d0dc", function () {
      api.rerender('5e92d0dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/dialogs/download-work-permit-dialog/download-work-permit-dialog.component.vue"
export default component.exports